import { render, staticRenderFns } from "./QyGroupDinnerIndex.vue?vue&type=template&id=e55e5e88&scoped=true"
import script from "./QyGroupDinnerIndex.vue?vue&type=script&lang=js"
export * from "./QyGroupDinnerIndex.vue?vue&type=script&lang=js"
import style0 from "./QyGroupDinnerIndex.vue?vue&type=style&index=0&id=e55e5e88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55e5e88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55e5e88')) {
      api.createRecord('e55e5e88', component.options)
    } else {
      api.reload('e55e5e88', component.options)
    }
    module.hot.accept("./QyGroupDinnerIndex.vue?vue&type=template&id=e55e5e88&scoped=true", function () {
      api.rerender('e55e5e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/qy_group_dinner/QyGroupDinnerIndex.vue"
export default component.exports